import { useMemo } from 'react';
import { useFetchTemplatesQuery } from '../service';

type Params = {
    includeDefault?: boolean;
};

export default function useGetSortedTemplates({ includeDefault = true }: Params) {
    const { data: templates, isFetching: isFetchingTemplates, isLoading: isLoadingTemplates } = useFetchTemplatesQuery();

    const sortedTemplates = useMemo(
        () => templates && [...templates].sort((a, b) => b.last_modified - a.last_modified).filter((template) => includeDefault || template.guid !== 'default'),
        [includeDefault, templates]
    );

    return {
        sortedTemplates,
        isFetchingTemplates,
        isLoadingTemplates,
    };
}
